export default "__VITE_ASSET__CmwJAVGx__"